<form>
  <div fxLayout="row" fxLayoutAlign="center center">
    <div fxFlex="400px" [formGroup]="editForm">
      <mat-card appearance="outlined" class="sign-in-card">
        <div fxLayout="column" fxFlexFill fxLayoutAlign="start stretch">
          <h3 mat-dialog-title>{{'ログイン' | translate}}</h3>
          <!-- #216 プルダウンで日本語か英語か選択 -->
          <mat-form-field>
            <mat-label>{{'言語選択' | translate}}</mat-label>
            <mat-select id="current_language" formControlName="current_language" required
              (selectionChange)="switchLanguage($event.value)">
              <mat-option value="ja">{{'日本語' | translate}}</mat-option>
              <mat-option value="en">{{'英語' | translate}}</mat-option>
            </mat-select>
          </mat-form-field>
          <div fxLayout="row" fxFlexFill fxLayoutAlign="space-between center">
            <span style="color: #000000; font-size:14px;">
              {{ '▼グーグル・アカウントによるログイン' | translate }}
            </span>
          </div>
          <div fxLayout="row" fxFlexFill fxLayoutAlign="space-between center">
            <div fxFlex></div>
            <button mat-button color="primary" (click)="loginGoogle()"><mat-icon
                class="mat-icon-event-btn">login</mat-icon>{{'ログイン' | translate}}</button>
          </div>
          <div fxLayout="row" fxFlexFill fxLayoutAlign="space-between center">
            <div fxFlex>
              <hr size="2" noshade="" color="#0000FF">
            </div>
          </div>
          <div class="mail-login-area" fxLayout="row" fxFlexFill fxLayoutAlign="space-between center">
            <span class="mail-login-title">
              {{'▼メール・パスワードによるログイン' | translate}}
            </span>
          </div>
          <mat-form-field>
            <mat-label>{{'メールアドレス' | translate}}</mat-label>
            <input matInput type="email" placeholder="{{'メールアドレス' | translate}}" id="admin_id"
              formControlName="admin_id" autocomplete="off" required>
            <mat-error *ngIf="adminIdControl.invalid">{{ getErrorMessageToAdminId() }}</mat-error>
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{'パスワード' | translate}}</mat-label>
            <input matInput type="password" placeholder="{{'パスワード' | translate}}" id="password"
              formControlName="password" autocomplete="off" required>
            <mat-error *ngIf="passwordControl.invalid">{{ getErrorMessageToPassword() }}</mat-error>
          </mat-form-field>
          <div fxLayout="row" fxFlexFill fxLayoutAlign="space-between center">
            <button mat-button color="accent" routerLink="/sign-up" cdkFocusInitial><mat-icon class="mat-icon-event-btn">reply</mat-icon>{{ 'アカウント作成へ' | translate }}</button>
            <button mat-button color="primary" (click)="loginMail()" [disabled]="editForm.invalid"><mat-icon class="mat-icon-event-btn">login</mat-icon>{{ 'ログイン' | translate }}</button>
          </div>
          <div fxLayout="row" fxFlexFill fxLayoutAlign="space-between center">
            <button mat-button color="accent" routerLink="/password-reset-mail" cdkFocusInitial><mat-icon class="mat-icon-event-btn">reply</mat-icon>{{ 'パスワード再設定へ' | translate }}</button>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</form>